const SITE_KEY = '6LcUFMIsAAAAALQkKYNBSwnBumYJWthsJKWDSV9A';

export function getRecaptchaToken(action: string): Promise<string | null> {
  // reCAPTCHA falha em localhost — backend faz skip quando token está ausente
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    const g = (window as any).grecaptcha;
    if (!g) { resolve(null); return; }
    g.ready(async () => {
      try {
        const token = await g.execute(SITE_KEY, { action });
        resolve(token);
      } catch {
        resolve(null);
      }
    });
  });
}
